/* src/app/shared/process/process-list/process-list.component.scss */
.process-list {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0.5rem;
}
.process-list .grid {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.qb-process-item {
  width: 100%;
  height: 40px;
  object-fit: contain;
  display: block;
  padding: 0 !important;
}
a {
  padding: 0 !important;
}
/*# sourceMappingURL=process-list.component.css.map */
